import { memo } from "react";
import { Link } from "react-router";

const NOTION_URL = "https://chillnn.notion.site/21afffe15c5780108e07cf900ea70d2d";

export const PriceSettingDescription = memo(() => {
	return (
		<div className="space-y-1">
			<p>CHILLNNでは、部屋料金とプラン料金をそれぞれ設定することができます。</p>
			<p>このページでは、食事付きプランなど、部屋料金に追加するプラン料金の設定ができます。</p>
			<p>
				<Link
					to={NOTION_URL}
					className="text-link-400 underline-offset-4 hover:underline"
					target="_blank"
					viewTransition
				>
					詳しくはこちら
				</Link>
			</p>
		</div>
	);
});

PriceSettingDescription.displayName = "PriceSettingDescription";
